import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, X, ArrowRight, Zap, Star, Crown, HelpCircle } from 'lucide-react';
import SiteNav from '../../components/site/SiteNav';
import SiteFooter from '../../components/site/SiteFooter';

const Pricing = () => {
    const [billingCycle, setBillingCycle] = useState('monthly');

    const plans = [
        {
            id: 'free',
            name: 'Başlangıç',
            icon: <Zap size={22} />,
            price: { monthly: '0', yearly: '0' },
            desc: 'QR menü ile dijital dönüşüme ilk adım',
            cta: 'Ücretsiz Başla',
            ctaLink: '/signup',
            features: [
                { name: 'Dijital QR Menü Yönetimi', included: true },
                { name: 'İşletme Profili', included: true },
                { name: 'Müşteri Kaydı (arka planda)', included: true },
                { name: 'Müşteri Yönetim Paneli', included: false },
                { name: 'Sipariş Yönetimi', included: false },
                { name: 'Kampanya & Ödüller', included: false },
                { name: 'Analitik & Raporlar', included: false },
                { name: 'Stok & Muhasebe', included: false },
                { name: 'Ekip Yönetimi', included: false },
                { name: 'Ödeme Entegrasyonları', included: false },
                { name: 'AI Danışman', included: false },
            ]
        },
        {
            id: 'pro',
            name: 'Pro',
            icon: <Star size={22} />,
            price: { monthly: '990', yearly: '9.500' },
            desc: 'Büyüyen işletmeler için tam donanımlı CRM',
            popular: true,
            cta: 'Pro\'ya Geç',
            ctaLink: '/checkout?plan=pro',
            features: [
                { name: 'Dijital QR Menü Yönetimi', included: true },
                { name: 'İşletme Profili & Tüm Ayarlar', included: true },
                { name: 'Sınırsız Müşteri Yönetimi', included: true },
                { name: 'Sipariş Yönetimi', included: true },
                { name: 'Kampanya, Ödül & Kuponlar', included: true },
                { name: 'Detaylı Analitik & Raporlar', included: true },
                { name: 'Stok & Muhasebe Modülü', included: true },
                { name: 'Ekip Yönetimi & Roller', included: true },
                { name: 'Bildirim & Duyuru Sistemi', included: true },
                { name: 'Ödeme Entegrasyonları', included: false },
                { name: 'AI Danışman', included: false },
            ]
        },
        {
            id: 'premium',
            name: 'Premium',
            icon: <Crown size={22} />,
            price: { monthly: '1.990', yearly: '19.900' },
            desc: 'AI destekli tam kapsamlı işletme yönetimi',
            cta: 'Premium\'a Geç',
            ctaLink: '/checkout?plan=premium',
            gradient: true,
            features: [
                { name: 'Dijital QR Menü Yönetimi', included: true },
                { name: 'İşletme Profili & Tüm Ayarlar', included: true },
                { name: 'Sınırsız Müşteri Yönetimi', included: true },
                { name: 'Sipariş Yönetimi', included: true },
                { name: 'Kampanya, Ödül & Kuponlar', included: true },
                { name: 'Detaylı Analitik & Raporlar', included: true },
                { name: 'Stok & Muhasebe Modülü', included: true },
                { name: 'Ekip Yönetimi & Roller', included: true },
                { name: 'Bildirim & Duyuru Sistemi', included: true },
                { name: 'Ödeme Entegrasyonları (iyzico+)', included: true },
                { name: 'AI Danışman (Gemini)', included: true },
            ]
        }
    ];

    const faqs = [
        { q: 'Ücretsiz plan gerçekten ücretsiz mi?', a: 'Evet, başlangıç planı tamamen ücretsiz. QR menü oluşturup müşterilerinize dijital menü sunabilirsiniz. Kredi kartı gerekmez.' },
        { q: 'Planlar arası geçiş yapabilir miyim?', a: 'Evet, istediğiniz zaman üst plana geçebilirsiniz. Mevcut verileriniz korunur.' },
        { q: 'Free planda müşteri verileri toplanıyor mu?', a: 'Evet, check-in yapan müşterilerinizin verileri arka planda toplanır. Pro veya Premium plana geçtiğinizde tüm birikmiş verilerinize erişebilirsiniz.' },
        { q: 'Ödeme yöntemi nedir?', a: 'iyzico altyapısı ile güvenli kredi kartı/banka kartı ile ödeme yapabilirsiniz. Taksit seçenekleri mevcuttur.' },
    ];

    return (
        <div className="pricing-page" style={{ background: 'var(--bg-main)', color: 'var(--text-main)', minHeight: '100vh', overflowX: 'hidden' }}>
            <SiteNav />
            <style>{`
                .pricing-card { background: var(--bg-card); border: 2px solid var(--border); border-radius: 24px; padding: 2.5rem; display: flex; flex-direction: column; position: relative; transition: all 0.3s; }
                .pricing-card:hover { transform: translateY(-4px); box-shadow: 0 20px 40px -10px rgba(0,0,0,0.1); }
                .pricing-card.popular { border-color: var(--primary); box-shadow: 0 20px 40px -10px rgba(var(--primary-rgb), 0.15); }
                .pricing-card.gradient-border { border-color: #c026d3; }
                .billing-toggle { display: flex; background: var(--bg-card); border: 1px solid var(--border); padding: 4px; border-radius: 14px; }
                .billing-btn { padding: 10px 24px; border-radius: 10px; font-size: 0.875rem; font-weight: 700; border: none; cursor: pointer; transition: all 0.2s; }
                .faq-item { background: var(--bg-card); border: 1px solid var(--border); border-radius: 16px; padding: 1.5rem; }
                @media (max-width: 900px) { .pricing-grid { grid-template-columns: 1fr !important; max-width: 400px !important; margin: 0 auto !important; } }
                @media (max-width: 768px) { .pricing-section { padding: 10rem 5% 4rem !important; } .pricing-page section { padding-left: 5% !important; padding-right: 5% !important; } .pricing-card { padding: 1.75rem !important; } .faq-grid { grid-template-columns: 1fr !important; } }
            `}</style>

            <section className="pricing-section" style={{ padding: '14rem 10% 4rem', textAlign: 'center' }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(var(--primary-rgb), 0.1)', color: 'var(--primary)', padding: '8px 16px', borderRadius: 99, fontSize: '0.8125rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: '1.5rem' }}>
                    <Star size={14} /> Fiyatlandırma
                </div>
                <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)', fontWeight: 900, letterSpacing: '-0.03em', marginBottom: '1rem' }}>Her İşletmeye Uygun Plan</h1>
                <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem', maxWidth: 550, margin: '0 auto 3rem' }}>Ücretsiz başlayın, büyüdükçe yükseltin. Tüm planlar anında aktif.</p>

                <div className="billing-toggle" style={{ display: 'inline-flex', marginBottom: '3rem' }}>
                    <button className="billing-btn" onClick={() => setBillingCycle('monthly')} style={{ background: billingCycle === 'monthly' ? 'var(--primary)' : 'transparent', color: billingCycle === 'monthly' ? 'white' : 'var(--text-muted)' }}>Aylık</button>
                    <button className="billing-btn" onClick={() => setBillingCycle('yearly')} style={{ background: billingCycle === 'yearly' ? 'var(--primary)' : 'transparent', color: billingCycle === 'yearly' ? 'white' : 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 6 }}>
                        Yıllık <span style={{ background: '#10b98120', color: '#10b981', padding: '2px 8px', borderRadius: 6, fontSize: '0.65rem', fontWeight: 800 }}>%20</span>
                    </button>
                </div>

                <div className="pricing-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem', maxWidth: 1100, margin: '0 auto' }}>
                    {plans.map(plan => (
                        <div key={plan.id} className={`pricing-card ${plan.popular ? 'popular' : ''} ${plan.gradient ? 'gradient-border' : ''}`}>
                            {plan.popular && <div style={{ position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)', background: 'var(--primary)', color: 'white', padding: '4px 16px', borderRadius: 20, fontSize: '0.7rem', fontWeight: 800, textTransform: 'uppercase', whiteSpace: 'nowrap' }}>En Popüler</div>}
                            <div style={{ color: plan.gradient ? '#c026d3' : plan.popular ? 'var(--primary)' : 'var(--text-muted)', marginBottom: '0.5rem' }}>{plan.icon}</div>
                            <h3 style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: '0.25rem' }}>{plan.name}</h3>
                            <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '1.5rem', minHeight: 40 }}>{plan.desc}</p>
                            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: '2rem' }}>
                                <span style={{ fontSize: '2.75rem', fontWeight: 900 }}>{billingCycle === 'yearly' ? plan.price.yearly : plan.price.monthly}</span>
                                <span style={{ color: 'var(--text-muted)', fontSize: '0.875rem', fontWeight: 600 }}> ₺/{billingCycle === 'yearly' ? 'yıl' : 'ay'}</span>
                            </div>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2rem' }}>
                                {plan.features.map((f, i) => (
                                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        {f.included ? <Check size={16} style={{ color: '#10b981', flexShrink: 0 }} /> : <X size={16} style={{ color: 'var(--border)', flexShrink: 0 }} />}
                                        <span style={{ fontSize: '0.875rem', fontWeight: 600, color: f.included ? 'var(--text-main)' : 'var(--text-muted)' }}>{f.name}</span>
                                    </div>
                                ))}
                            </div>
                            <Link to={plan.ctaLink} style={{
                                display: 'block', textAlign: 'center', padding: '14px', borderRadius: 14, fontWeight: 800, fontSize: '0.9375rem', textDecoration: 'none',
                                background: plan.popular ? 'var(--primary)' : plan.gradient ? 'linear-gradient(135deg, var(--primary), #c026d3)' : 'var(--bg-main)',
                                color: (plan.popular || plan.gradient) ? 'white' : 'var(--text-main)',
                                border: (!plan.popular && !plan.gradient) ? '1px solid var(--border)' : 'none'
                            }}>
                                {plan.cta} <ArrowRight size={16} style={{ verticalAlign: 'middle', marginLeft: 4 }} />
                            </Link>
                        </div>
                    ))}
                </div>
            </section>

            {/* FAQ */}
            <section style={{ padding: '6rem 10%' }}>
                <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                    <h2 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: '0.5rem' }}>Sık Sorulan Sorular</h2>
                    <p style={{ color: 'var(--text-muted)' }}>Plan seçimiyle ilgili merak edilenler</p>
                </div>
                <div className="faq-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', maxWidth: 900, margin: '0 auto' }}>
                    {faqs.map((faq, i) => (
                        <div key={i} className="faq-item">
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: '0.75rem' }}>
                                <HelpCircle size={18} style={{ color: 'var(--primary)', flexShrink: 0, marginTop: 2 }} />
                                <span style={{ fontWeight: 700, fontSize: '0.9375rem' }}>{faq.q}</span>
                            </div>
                            <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', lineHeight: 1.6, paddingLeft: 28 }}>{faq.a}</p>
                        </div>
                    ))}
                </div>
            </section>

            <SiteFooter />
        </div>
    );
};

export default Pricing;
